import { Image } from 'antd';

const NFTLoading = () => {
  return <div className={'nft-loading'}>
    <Image src="../loading_shard.gif" className={'loading-mask-icon'} preview={false}></Image>
  </div>
}

export default NFTLoading;